const getVariationImage = (variation) => {
    if (!variation || typeof variation !== 'object') {
        return {};
    }

    return variation.image || {};
};

const getVariationImageSrc = (variation) => {
    const image = getVariationImage(variation);

    return image.src || image.full_src || image.thumb_src || image.gallery_thumbnail_src || '';
};

const getVariationThumbSrc = (variation) => {
    const image = getVariationImage(variation);

    return image.gallery_thumbnail_src || image.thumb_src || image.src || image.full_src || '';
};

const shouldUseVariationImage = (variation) => Boolean(getVariationImageSrc(variation));

const getGalleryLightboxGroup = (links) => {
    const fallbackGroup = 'woogallery_0';

    if (!Array.isArray(links)) {
        return fallbackGroup;
    }

    const groupLink = links.find((link) => {
        if (!link || typeof link.getAttribute !== 'function') {
            return false;
        }

        return link.getAttribute('data-fancybox') || link.getAttribute('data-fancybox-group');
    });

    return groupLink?.getAttribute('data-fancybox') || groupLink?.getAttribute('data-fancybox-group') || fallbackGroup;
};

export { getGalleryLightboxGroup, getVariationImageSrc, getVariationThumbSrc, shouldUseVariationImage };
